export default "/_next/static/images/service-training-desktop-3x-027a03063b1e0c2c518d76a6341cdd8f.jpg";